import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getStudentClasses } from '../api/studentsClass.api';
import { IStudentClass, IGetStudentClasses } from '../models/studentsClass.model';

interface IStudentClassState {
  studentClasses: IStudentClass[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IStudentClassState = {
  studentClasses: [],
  isLoading: false
};

const studentClassSlicer = createSlice({
  name: 'studentClass',
  initialState,
  reducers: {
    getStudentClassesStart: (state: IStudentClassState) => {
      state.studentClasses = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentClassesSuccess: (state: IStudentClassState, action: PayloadAction<IGetStudentClasses>) => {
      state.studentClasses = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentClassesFailure: (state: IStudentClassState, action: PayloadAction<AxiosError | string>) => {
      state.studentClasses = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  }
});

export const {
  getStudentClassesStart,
  getStudentClassesSuccess,
  getStudentClassesFailure,
} = studentClassSlicer.actions;

export default studentClassSlicer.reducer;

export const doGetStudentClasses = (studentCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getStudentClassesStart());
    const response = await getStudentClasses(studentCode);
    dispatch(getStudentClassesSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getStudentClassesFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
